import { createContext, useContext, useReducer, useMemo, useCallback } from "react";
import PropTypes from "prop-types";

// Create context
const HomeworkReducer = createContext();

// Setting custom name for the context which is visible on react dev tools
HomeworkReducer.displayName = "HomeworkContext";

// App reducer
import reducer from "./homework-reducer.js";

// Material Dashboard 2 React context provider
const initialState = {
  todo: {},
  homeworks: {},
  milestones: {},
};

function HomeworkProvider({ children }) {
  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return <HomeworkReducer.Provider value={value}>{children}</HomeworkReducer.Provider>;
}

// Custom hook for using context
function useHomework() {
  const context = useContext(HomeworkReducer);

  return context;
}

// Typechecking props for the MaterialUIControllerProvider
HomeworkProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export * from "./homework-actions.js";
export { HomeworkProvider, useHomework };
